import {LIST_CARE_UNITS, LIST_OPTICIAN_SHOPS, LIST_OPTICIAN_USERS, SEND_REFERRAL} from './ReferralActionTypes';
import {catchError, map, switchMap} from 'rxjs/operators';
import {combineEpics} from 'redux-observable';
import config from 'react-global-configuration';
import {referralActions} from './'
import { navigate } from '../../../navigation';
import {referral} from './ReferralSelectors'
import {errorHandlingWithLogoutCheck, getJsonWithAuth, postJsonWithAuth,} from "../../../components/AjaxHelpers";

export const referralEpics = combineEpics(
    (action$, state$) => action$.ofType(LIST_CARE_UNITS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/careUnits/v1',
                state: state$.value
            }).pipe(
                map(payload => referralActions.listCareUnitsSucceeded(payload)),
                catchError(response => {
                    if (response.status !== 401) {
                        navigate('/error');
                    }
                    return errorHandlingWithLogoutCheck(response, [referralActions.listCareUnitsFailed(response)]);
                })
            )
        )
    ),

    (action$, state$) => action$.ofType(LIST_OPTICIAN_SHOPS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/opticians/v1',
                state: state$.value
            }).pipe(
                map(payload => referralActions.listOpticianShopsSucceeded(payload)),
                catchError(response => {
                    if (response.status !== 401) {
                        navigate('/error');
                    }
                    return errorHandlingWithLogoutCheck(response, [referralActions.listOpticianShopsFailed(response)]);
                })
            )
        )
    ),

    (action$, state$) => action$.ofType(LIST_OPTICIAN_USERS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/opticians/v1/users',
                state: state$.value
            }).pipe(
                map(payload => referralActions.listOpticianUsersSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [referralActions.listOpticianUsersFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(SEND_REFERRAL).pipe(
        switchMap(action =>
            postJsonWithAuth({
                url: config.get('apiBaseUrl') + '/referrals/v1',
                body: {
                    ...referral(state$.value)
                },
                state: state$.value,
                responseType: 'blob', //maps to otherParams
            }).pipe(
                map(payload => referralActions.sendReferralSuccess(payload)),
                catchError(error => errorHandlingWithLogoutCheck(error, [referralActions.sendReferralFailure(error)]))
            )
        )
    ),
);